export default {
    // C
    capture: 'Capture',
    chooseAnImage: 'Choose an image from your video or upload from your device.',
    confirmMediaDuplication: 'confirm media duplication',
    confirmMediaDuplicationText: 'Your new copy will include the raw media when duplicating a media card. Please note that new versions will not be included.',
    customizeThumbnail: 'Customize thumbnail',

    // P
    playYourVideo: 'Play your video and pause it at the frame you wish to use as the cover image. Click on the "Capture" button to save the preview image.',

    // S
    saveImage: 'Save image',
}
